<template>
  <div class="array-panel">
    <!-- 方阵标题栏 -->
    <div class="array-header" @click="toggleExpand">
      <div class="array-title">{{ arrayData.name }}</div>
      <img src="@/assets/images/station-monitor/detail-dialog/collapse-icon.png" class="collapse-icon"
        :class="{ 'expanded': isExpanded }" alt="展开/收起" />
    </div>

    <!-- 方阵内容（使用CSS过渡） -->
    <transition name="panel-expand">
      <div v-show="isExpanded" class="array-content-wrapper">
        <div class="array-content">
          <!-- eLink 信息卡片（左侧） -->
          <div
            v-memo="[arrayData.elink.uuid, arrayData.elink.airconds, highlightedDevice.type === 'eLink' && highlightedDevice.id === arrayData.elink.uuid]"
            class="elink-info-card" :data-device-id="arrayData.elink.uuid"
            :class="{ 'highlight-device': highlightedDevice.type === 'eLink' && highlightedDevice.id === arrayData.elink.uuid }">
            <!-- eLink标题和详情按钮 -->
            <div class="elink-header">
              <div class="header-left">
                <div class="elink-label">冷却方式：{{ arrayData.elink.coolingMode }}</div>
                <div class="elink-name mr-2">{{ arrayData.elink.name }}</div>
              </div>
              <div class="detail-link" @click.stop="$emit('open-elink-detail', arrayData.elink)">详情</div>
            </div>

            <!-- eLink中间图表区域 -->
            <div class="elink-chart-area">
              <div class="elink-device-image">
                 <!-- 消防主机图片，暂时沿用或替换 -->
                <img src="@/assets/images/station-monitor/detail-dialog/elink-device.png" alt="elink"
                  loading="lazy" />
              </div>
              <div class="device-name">{{ arrayData.elink.model }}</div>
            </div>

            <!-- eLink底部信息区域 -->
            <div class="elink-info-list">
              <v-carousel 
                v-if="arrayData.elink.airconds && arrayData.elink.airconds.length > 0"
                :show-arrows="false"
                cycle
                height="100%"
                interval="5000"
                class="custom-carousel"
                hide-delimiter-background
                :touch="{ left: () => {}, right: () => {} }"
              >
                <v-carousel-item v-for="(ac, idx) in arrayData.elink.airconds" :key="idx">
                   <div class="ac-info-grid">
                      <div class="info-row">
                        <span class="label">空调状态</span>
                        <div class="value-wrapper">
                           <div class="status-indicator" :style="{ backgroundColor: ac.onOff === 1 ? '#36B60C' : '#999' }"></div>
                           <span class="value" :style="{ color: ac.onOff === 1 ? '#36B60C' : '#999' }">{{ ac.onOff === 1 ? '开机' : ac.onOff === 0 ? '关机' : '--' }}</span>
                        </div>
                      </div>
                      <div class="info-row">
                        <span class="label">空调机组状态</span>
                         <span class="value">{{ getWorkStatusText(ac.workState) }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">湿度</span>
                        <div class="value-wrapper">
                           <!-- <div class="progress-bar-mock"></div> -->
                            <div class="soc-progress-bar">
                                <div class="soc-fill" :style="{ width: (ac.humity || 0) + '%' }"></div>
                            </div>
                           <span class="value">{{ ac.humity !== undefined ? ac.humity + '%' : '--' }}</span>
                        </div>
                      </div>
                      <div class="info-row">
                        <span class="label">回风温度</span>
                        <span class="value">{{ ac.temp !== undefined ? ac.temp + '℃' : '--' }}</span>
                      </div>
                   </div>
                </v-carousel-item>
              </v-carousel>
              <div v-else class="no-data">暂无空调数据</div>
            </div>
          </div>

          <!-- 右侧：eBlock列表区域 -->
          <div class="right-content-wrapper">
             <!-- eBlock 头部信息 -->
             <div class="eblock-header-info">
                <span class="info-item">eBlock型号：<span class="val">{{ arrayData.eblockModel }}</span></span>
                <span class="info-item ml-4">冷却方式：<span class="val">{{ arrayData.coolingMode }}</span></span>
             </div>

            <!-- 能量块网格（右侧） -->
            <div class="energy-blocks-grid">
              <div v-for="block in arrayData.blocks" :key="block.uuid"
                v-memo="[block.uuid, block.airconds, block.hasWarning, highlightedDevice.type === 'eBlock' && highlightedDevice.id === block.uuid]"
                class="block-card" :data-device-id="block.uuid"
                :class="{ 'highlight-device': highlightedDevice.type === 'eBlock' && highlightedDevice.id === block.uuid }">
                <!-- 顶部标题和状态栏 -->
                <div class="block-status-bar">
                  <div class="block-title">{{ block.name }}</div>
                  <div class="status-badges">
                    <v-badge location="top right" color="#FF7867" :content="block.alarmCount" v-if="block.alarmCount > 0" class="mr-2">
                       <div class="warning-btn" @click.stop="$emit('open-eblock-alarm-history', block)">告警</div>
                    </v-badge>
                    <div class="detail-text-btn" @click.stop="$emit('open-eblock-detail', block)">详情</div>
                  </div>
                </div>

                <!-- 主内容区域 -->
                <div class="block-content-wrapper">
                  <!-- 右侧信息区域 - 调整样式 -->
                  <div class="block-info">
                    <v-carousel 
                      v-if="block.airconds && block.airconds.length > 0"
                      :show-arrows="false"
                      cycle
                      height="100%"
                      interval="5000"
                      class="custom-carousel"
                      hide-delimiter-background
                      :touch="{ left: () => {}, right: () => {} }"
                    >
                      <v-carousel-item v-for="(ac, idx) in block.airconds" :key="idx">
                        <div class="ac-info-grid">
                            <div class="info-row">
                              <span class="label">开关机状态</span>
                              <div class="value-wrapper">
                                <div class="status-indicator" :style="{ backgroundColor: ac.onOff === 1 ? '#36B60C' : '#FF8A67' }"></div>
                                <span class="value" :style="{ color: ac.onOff === 1 ? '#36B60C' : '#FF8A67' }">{{ ac.onOff === 1 ? '开机' : ac.onOff === 0 ? '关机' : '--' }}</span>
                              </div>
                            </div>
                            <div class="info-row">
                              <span class="label">空调机组状态</span>
                              <span class="value">{{ getWorkStatusText(ac.workState) }}</span>
                            </div>
                            <div class="info-row">
                              <span class="label">湿度</span>
                               <div class="value-wrapper">
                                 <!-- <div class="progress-bar-small"></div> -->
                                 <div class="soc-progress-bar">
                                    <div class="soc-fill" :style="{ width: (ac.humity !== undefined ? ac.humity : 0) + '%' }"></div>
                                 </div>
                                 <span class="value">{{ ac.humity !== undefined ? ac.humity + '%' : '--' }}</span> 
                               </div>
                            </div>
                             <div class="info-row">
                              <span class="label">回风温度</span>
                              <span class="value">{{ ac.temp !== undefined ? ac.temp + '℃' : '--' }}</span>
                            </div>
                        </div>
                      </v-carousel-item>
                    </v-carousel>
                    <div v-else class="no-data">暂无空调数据</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  arrayData: {
    type: Object,
    required: true
  },
  highlightedDevice: {
    type: Object,
    default: () => ({ type: null, id: null })
  },
  defaultExpanded: {
    type: Boolean,
    default: true
  }
})

defineEmits(['open-elink-detail', 'open-eblock-detail', 'open-eblock-alarm-history'])

const isExpanded = ref(props.defaultExpanded)

const toggleExpand = () => {
  isExpanded.value = !isExpanded.value
}

// 暴露展开方法给父组件调用
const expand = () => {
  isExpanded.value = true
}

const getWorkStatusText = (status) => {
  const map = {
    0: '关机',
    1: '送风',
    2: '制冷',
    3: '加热',
    4: '除湿'
  }
  return map[status] || '--'
}

defineExpose({
  expand
})
</script>

<style scoped lang="scss">
.array-panel {
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  overflow: visible;
}

.array-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 22px;
  cursor: pointer;
  user-select: none;
  border-radius: 20px 20px 0 0;

  &:hover {
    background-color: rgba(246, 251, 255, 0.5);
  }
}

.array-title {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 16px;
  color: rgba(46, 46, 46, 1);
  font-weight: normal;
}

.collapse-icon {
  width: 11px;
  height: 6px;
  transition: transform 0.3s ease;

  &.expanded {
    transform: rotate(180deg);
  }
}

/* 过渡动画 */
.panel-expand-enter-active,
.panel-expand-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.panel-expand-enter-from,
.panel-expand-leave-to {
  max-height: 0;
  opacity: 0;
}

.panel-expand-enter-to,
.panel-expand-leave-from {
  max-height: 2000px;
  opacity: 1;
}

.array-content-wrapper {
  padding: 0 22px 20px;
}

.array-content {
  display: flex;
  gap: 18px;
}

/* eLink 信息卡片 */
.elink-info-card {
  min-width: 275px;
  height: 100%;
  width: 275px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  border: 1px solid rgba(244, 247, 252, 1);
  border-radius: 10px;
  padding: 2px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  will-change: border-color, box-shadow;
  overflow: visible;

  &.highlight-device {
    animation: highlightBlink 0.5s ease-in-out 6;
  }

  .detail-link {
    font-size: 14px;
    color: #3A68FF;
    cursor: pointer;
  }

  .elink-chart-area {
    width: 100%;
    // height: 261px;
    background: linear-gradient(0deg, rgba(239, 244, 251, 0.7) 0%, rgba(255, 255, 255, 0.7) 100%);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .device-name {
    font-family: "HarmonyOS Sans SC";
    padding: 24px;
    font-size: 12px;
    color: rgba(46, 46, 46, 1);
  }
}

@keyframes highlightBlink {

  0%,
  100% {
    border-color: rgba(244, 247, 252, 1);
    box-shadow: none;
  }

  50% {
    border-color: rgba(58, 104, 255, 1);
    box-shadow: 0 0 12px rgba(58, 104, 255, 0.5);
  }
}

.elink-header {
  width: 100%;
  height: 48px;
  background: rgba(239, 244, 251, 0.7);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  box-sizing: border-box;
}

.header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 85%;
}

.elink-label {
  font-size: 14px;
}

.elink-name {
  font-size: 14px;
}

.ml-2 {
  margin-left: 8px;
}

.mr-2 {
  margin-right: 8px;
}

.elink-info-list {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(239, 244, 251, 0.7) 0%, rgba(255, 255, 255, 0.7) 100%);
  border-radius: 5px;
  padding: 10px 15px;
  box-sizing: border-box;
  overflow: hidden;
  justify-content: center;
}

/* 右侧 wrapper */
.right-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #F4F7FC;
  border-radius: 5px;
}

/* eBlock 头部 */
.eblock-header-info {
  width: 100%;
  height: 48px;
  background: rgba(239, 244, 251, 0.70);
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.info-item {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
  
  .val {
     font-weight: 400;
     margin-left: 5px;
  }
}

.ml-4 {
  margin-left: 20px;
}

/* 能量块网格 */
.energy-blocks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
  align-content: start;
  padding: 0 16px;
}

/* 能量块卡片 */
.block-card {
  position: relative;
  min-width: 260px;
  width: 100%;
  min-height: 160px; /* Reduced height */
  background: rgba(239, 244, 251, 0.7);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid transparent;
  transition: border-color 0.3s ease;
  will-change: border-color, box-shadow;

  &.highlight-device {
    animation: highlightBlink 0.5s ease-in-out 6;
  }
}

.block-status-bar {
  position: relative;
  width: 100%;
  height: 40px; /* Reduced height */
  background: rgba(239, 244, 251, 0.7);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
}

.status-badges {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.warning-btn {
  padding: 4px 10px;
  background: #fff;
  border-radius: 12px;
  font-size: 12px;
}

.detail-text-btn {
  font-size: 14px;
  color: #3A68FF;
  cursor: pointer;
}

.block-content-wrapper {
  display: flex;
  padding: 10px 15px 15px;
  flex: 1;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
}

.block-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0;
  height: 100%;
}

.ac-info-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 0;

  .label {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 12px;
    color: #2E2E2E;
  }

  .value-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .value {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    color: rgba(46, 46, 46, 1);
    font-weight: 500;
  }

  .status-indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
}


  .soc-progress-bar {
    width: 60px;
    height: 8px;
    background: rgba(239, 244, 251, 1);
    border-radius: 20px;
    overflow: hidden;
    margin-right: 4px;

    .soc-fill {
      height: 100%;
      background: linear-gradient(270deg, rgba(141, 211, 245, 1) 5.77%, rgba(184, 229, 214, 1) 52.89%, rgba(222, 248, 179, 1) 100%);
      border-radius: 20px;
      transition: width 0.3s ease;
    }
  }

.no-data {
  text-align: center;
  color: #999;
  font-size: 12px;
  padding: 20px 0;
}

/* Carousel fixes */
.custom-carousel {
  :deep(.v-window__container) {
    height: 100% !important;
  }
  :deep(.v-carousel__item) {
    height: 100% !important;
  }
  
  :deep(.v-carousel__controls) {
    height: 20px !important;
    background: transparent !important;
    
    .v-btn {
      width: 6px !important;
      height: 6px !important;
      margin: 0 4px !important;
      
      .v-btn__content {
         font-size: 0 !important;
      }
      
      &.v-btn--active {
         .v-icon {
            color: #2F51FF !important;
            opacity: 1 !important;
         }
      }
      
      .v-icon {
         font-size: 6px !important;
         width: 6px !important;
         height: 6px !important;
         color: #D6D6D6 !important;
         opacity: 1 !important;
      }
    }
  }
}
</style>

